import { GetterTree } from "vuex";
import { IDataProvider, IRootState } from "@/store";
import { IEntityApprovalRequest } from "@/types/common/entityApproval/EntityApproval";
import { IEntityApprovalState } from "@/store/modules/entityApproval/state";

export enum EntityApprovalGetters {
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_ENTITY_APPROVAL",
}

export const getters: GetterTree<IEntityApprovalState, IRootState> = {
  [EntityApprovalGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<IEntityApprovalRequest> {
    return state.dataProvider;
  },
};
